import React from 'react'
import './style.css'

import Map from "../../assets/images/png/map-bkg.png"
import LineButton from '../../components/line-button'
import { Image } from 'antd'

const url= "https://page.line.me/justbuyme"; 

export default function ContactUs() {
    return (
        <div className="contact-container">
            <h1>ติดต่อเรา</h1>
            <div className="contact-box">
                <div className="contact-text">
                    <div style={{color:"#fd0088"}}>โทรศัพท์และอีเมล</div>
                    <div style={{color:"#fd0088"}}>ติดต่อฝ่ายขายดังนี้</div>
                    <div className="contact-text-small">
                        <h3 style={{marginBottom: 0, color:"#fd0088"}}>คุณเนย</h3>
                        <div> โทรศัพท์ 02-891-3300 ต่อ 122,</div>
                        <div>มือถือ 081-845-2288,</div>
                        <div>อีเมล 2288@bangkokgift.net</div>

                        <h3 style={{marginBottom: 0, color:"#fd0088"}}>คุณปุ๊ก</h3>
                        <div> โทรศัพท์ 02-891-3300 ต่อ 129,</div>
                        <div>มือถือ 081-810-1818,</div>
                        <div>อีเมล puk@bangkokgift.net</div>

                        <h3 style={{marginBottom: 0, color:"#fd0088"}}>คุณนุ๊ก</h3>
                        <div>โทรศัพท์ 02-891-3300 ต่อ 139,</div>
                        <div>มือถือ 080-070-8000,</div>
                        <div>อีเมล nuuk@bangkokgift.net หรือ nuukonn@gmail.com</div>
                        <div style={{color:"#fd0088"}}>หรือติดต่อทางไลน์ได้ที่</div>
                        <div style={{marginTop: 5}}>
                            <a href={url} target="_blank"  >
                            <LineButton width={"100%"} height={40}  />
                             </a>
                        </div>
                        
                    
                    </div>
                    <div style={{marginTop:10, color:"#fd0088"}}>สถานที่ตั้งและแผนที่</div>
                    <div className="contact-text-small">
                        <div>บริษัท แบงค์ค๊อกกิ๊ฟท์ จำกัด</div>
                        <div>1020 ถนนเทอดไทย ตลาดพลู เขตธนบุรี กรุงเทพฯ 10600</div>
                        <div>Tel: (02) 891 3300</div>
                        <div>Mobile: (081)-845 2288</div>
                        <div>Email: 2288@bangkokgift.net</div>
                    </div>
                </div>
            </div>

            <div className="contact-map">
                <h1>รูปเเผนที่ :</h1>
                <Image src={Map} />
                <h1>Google map :</h1>
                <div>
                    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3875.9713249313068!2d100.47188527576346!3d13.720185898023296!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x30e290228c87722b%3A0xe3eebc2f1238a6a1!2z4Lia4Lij4Li04Lip4Lix4LiXIOC5geC4muC4h-C4hOC5jOC4hOC4reC4geC4geC4tOC5iuC4n-C4l-C5jCDguIjguLPguIHguLHguJQ!5e0!3m2!1sth!2sth!4v1738428495868!5m2!1sth!2sth" width="100%" height="600" style={{border:0}} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                </div>
            </div>
        </div>
    )
}
